<div class="templates-list" *ngIf="templates.length && !editMode">
  <div class="template-item" *ngFor="let template of templates; index as i">
    <div class="template-info">
      <div *ngIf="template.name" class="template-text">
        <span>{{ template.name }}</span>
        <small>{{ template.updated_at | date: 'dd/MM/yyyy hh:mm' }}</small>
      </div>
      <div class="color-bullets">
        <div class="color-bullets-section" *ngIf="template.values.section">
          <span
            class="bullet"
            [ngStyle]="{ 'background-color': template.values.section.available.normal.none.fillStyle }"
            title="Section: Available Normal"></span>
          <span
            class="bullet"
            [ngStyle]="{ 'background-color': template.values.section.selected?.normal.none.fillStyle }"
            title="Section: Selected Normal"></span>
        </div>
        <div class="color-bullets-section" *ngIf="template.values.seat">
          <span
            class="bullet"
            [ngStyle]="{ 'background-color': template.values.seat.available.normal.none.fillStyle }"
            title="Seat: Available Normal"></span>
          <span
            class="bullet"
            [ngStyle]="{ 'background-color': template.values.seat.selected.normal.none.fillStyle }"
            title="Seat: Selected Normal"></span>
        </div>
      </div>
    </div>
    <div class="template-btns">
      <button
        title="Aplicar plantilla"
        class="action-btn"
        [ngClass]="{ active: editMode && editMode.id === template.id }"
        (click)="applyTemplate(template)">
        <img id="fillColor" alt="" />
      </button>
      <button
        title="Editar plantilla"
        class="action-btn"
        [ngClass]="{ active: editMode && editMode.id === template.id }"
        (click)="editTemplate(template)">
        <img id="edit" alt="" />
      </button>
    </div>
  </div>
</div>
<div *ngIf="editMode">
  <div class="editmode-header">
    <div class="d-flex align-items-center justify-content-between">
      <span>Editar plantilla</span>
      <button class="btn-secondary-action" (click)="editMode = null">Volver</button>
    </div>
    <input type="text" class="custom-input" [(ngModel)]="editMode.name" />
  </div>
  <div>
    <app-custom
      #customtemplate
      [master_custom_colors]="editMasterColors"
      [template]="true"
      (onTemplateDestroy)="onDestroyTemplate()"
      (onTemplateUpdate)="onUpdatedTemplate($event)"></app-custom>
  </div>
</div>
